import { render, staticRenderFns } from "./CLanguageSelect.vue?vue&type=template&id=6122e278"
import script from "./CLanguageSelect.vue?vue&type=script&lang=ts"
export * from "./CLanguageSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CSelect: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSelect/CSelect.vue').default})
